import React, { FunctionComponent, type JSX } from 'react';
import PlusInCircleIcon from '../svgAssets/PlusInCircleIcon';
import ClickableArea, { ClickableAreaColourVariant } from './ClickableArea';
import './ClickableArea.sass';

type Props = {
  onClick?: () => void;
  className?: string;
  isProcessing?: boolean;
  colourVariant?: ClickableAreaColourVariant;
  isDisabled?: boolean;
};

const CreateArea: FunctionComponent<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>
): JSX.Element => {
  return (
    <ClickableArea
      {...props}
      className={`create-area ${props.className ? props.className : ''}`}
    >
      <div className="flex space-x-3.5 items-center">
        <div className="create-icon-wrapper">
          <PlusInCircleIcon />
        </div>
        <span>{props.children}</span>
      </div>
    </ClickableArea>
  );
};

export default CreateArea;
